/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobPositionInfo model module.
 * @module model/JobPositionInfo
 * @version V1
 */
class JobPositionInfo {
    /**
     * Constructs a new <code>JobPositionInfo</code>.
     * @alias module:model/JobPositionInfo
     */
    constructor() { 
        
        JobPositionInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobPositionInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobPositionInfo} obj Optional instance to populate.
     * @return {module:model/JobPositionInfo} The populated <code>JobPositionInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobPositionInfo();

            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('statusId')) {
                obj['statusId'] = ApiClient.convertToType(data['statusId'], 'Number');
            }
            if (data.hasOwnProperty('position')) {
                obj['position'] = ApiClient.convertToType(data['position'], 'String');
            }
            if (data.hasOwnProperty('displayPosition')) {
                obj['displayPosition'] = ApiClient.convertToType(data['displayPosition'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobPositionInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobPositionInfo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['position'] && !(typeof data['position'] === 'string' || data['position'] instanceof String)) {
            throw new Error("Expected the field `position` to be a primitive type in the JSON string but got " + data['position']);
        }

        return true;
    }


}



/**
 * @member {Number} jobId
 */
JobPositionInfo.prototype['jobId'] = undefined;

/**
 * @member {Number} statusId
 */
JobPositionInfo.prototype['statusId'] = undefined;

/**
 * @member {String} position
 */
JobPositionInfo.prototype['position'] = undefined;

/**
 * @member {Number} displayPosition
 */
JobPositionInfo.prototype['displayPosition'] = undefined;






export default JobPositionInfo;

